<script lang="ts" setup>
import { watch } from 'vue';
import { RouteLocationNormalized, useRouter } from 'vue-router';
import AuthLayout from '@/layouts/auth.layout.vue';
import DashboardLayout from '@/layouts/dashboard.layout.vue';
import SubscriberLayout from '@/layouts/subscriber.layout.vue';
import ModalPage from '@/components/block/ModalPage.vue';
import { useAuthStore } from '@/store/auth.store';
import { useRoute } from 'vue-router';
import Loading from '@/components/block/Loading.vue';

import NotificationWidget from '@/components/block/NotificationWidget.vue';

const authStore = useAuthStore();

const router = useRouter();
const route = useRoute();

watch(() => [authStore.isAuthed, route.meta], () => {
  redirect(route);
});

router.beforeEach((route) => {
  redirect(route);
});

const redirect = (route: RouteLocationNormalized):void => {
  if (route.meta.redirect === false) {
    return;
  }

  if (!!route.meta.requiresAuth && authStore.isAuthed === false) {
    router.push('/login');
  }

  if (authStore.isAuthed === true) {
    if (route.meta.redirectIfAuthed && !route.meta.requiresAuth) {
      if (authStore.isSubscriber) {
        router.push('/my-account');
      } else {
        router.push('/dashboard');
      }
    } else if (!route.meta.subscriberPage && authStore.isSubscriber) {
      if (route.name != 'my-account') {
        router.push('/my-account');
      }
    }
  }
};

redirect(route);
</script>

<template>

  <Loading v-if="authStore.isAuthed === null" />
  <AuthLayout v-else-if="authStore.isAuthed === false || !route.meta.requiresAuth" />
	<SubscriberLayout v-else-if="authStore.isSubscriber" />
	<DashboardLayout v-else-if="authStore.isUser" />

	<ModalPage/>
	<NotificationWidget />
</template>